<!-- components/GuestBillingInfo.vue -->
<template>
    <BModal id="modal-tall" :model-value="modalDetail" scrollable centered title="CheckoutDetail" @update:modelValue="updateModal"> 
    <template #header>
      <div class="d-flex align-items-center justify-content-between modal-title w-100">
        <h5 class="">CheckOut Information</h5>
        <!-- <div class="d-flex align-items-center">
          <span class="mr-2">17/02/2025 16:00:00</span>
          <div class="bg-success rounded-circle" style="width: 10px; height: 10px;"></div>
          <span>online: Ruth</span>
        </div> -->
      </div>
      <BButton
        variant="link"
        class="close"
        @click="updateModal(false)"
      >
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    
    <div class="guest-info text-start" id="printArea">

      <!--  Kop & logo (print)  -->
      <div class="print-only text-center mb-4">
        <table class="w-full text-left border-collapse">
          <tbody>
            <tr class="border-b border-transparent">
              <td class="text-left pr-2">
                <img src="../../../public/img/hotel-deliriver.png" alt="Hotel Logo" style="width: 100px; height: auto;" />
              </td>
              <td class="text-left pr-2"><h3 class="mt-2 mb-0">Deli River Hotel</h3>
                <p class="mb-0">Jl. Raya Namorambe No. 129, Medan, Indonesia</p>
                <p class="mb-0">Phone: +62-61-7032967 | email: contact@hotel-deliriver.com</p>
              </td>
            </tr>
          </tbody>
        </table>
        <hr />
      </div>

      <h4 class="print-only text-align-center">CheckOut Receipt</h4>

      <div class="px-3 border-bottom">
          <p class="text-secondary fw-semibold mb-2">Guest Information</p>
          <table class="w-full text-left border-collapse">
              <tbody>
                  <tr class="border-b border-transparent">
                      <td class="text-left pr-2">ID/Passport</td>
                      <td class="text-left pr-2">:</td>
                      <td class="text-left fw-semibold">
                          {{ data?.reservation?.guest?.identity_number ?? '-' }}
                      </td>
                  </tr>
                  <tr class="border-b border-transparent">
                      <td class="text-left pr-2">Name</td>
                      <td class="text-left pr-2">:</td>
                      <td class="text-left fw-semibold">
                          {{ data?.reservation?.guest?.fullname ?? '-' }}
                      </td>
                  </tr>
                  <tr class="border-b border-transparent">
                      <td class="text-left pr-2">Contact</td>
                      <td class="text-left pr-2">:</td>
                      <td class="text-left fw-semibold">
                          0{{ data?.reservation?.guest?.phone ?? '-' }}
                      </td>
                  </tr>
                  <tr class="border-b border-transparent">
                      <td class="text-left pr-2">Check In</td>
                      <td class="text-left pr-2">:</td>
                      <td class="text-left fw-semibold">
                          {{ dateFormatter(data?.check_in_date) }}
                      </td>
                  </tr>
                      <tr class="border-b border-transparent">
                      <td class="text-left pr-2">Check Out</td>
                      <td class="text-left pr-2">:</td>
                      <td class="text-left fw-semibold">
                          {{ dateFormatter(data?.check_out_date) }}
                      </td>
                  </tr>
                  <tr class="border-b border-transparent">
                      <td class="text-left pr-2">Stay Duration</td>
                      <td class="text-left pr-2">:</td>
                      <td class="text-left fw-semibold">
                          {{ countDays(data?.check_in_date, data?.check_out_date) }}
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
      <br>
      <div class="px-3">
          <p class="text-secondary fw-semibold mb-2">Billing Detail</p>
          <table class="w-full text-left border-collapse">
              <tbody>
                  <tr class="border-b border-transparent">
                      <td class="text-left pr-2">Room Type</td>
                      <td class="text-left pr-2">:</td>
                      <td class="text-left fw-semibold">
                          {{ data?.reservation?.room?.room_category?.name ?? '-' }}
                      </td>
                      </tr>
                      <tr class="border-b border-transparent">
                      <td class="text-left pr-2">Room Number</td>
                      <td class="text-left pr-2">:</td>
                      <td class="text-left fw-semibold">
                          {{ data?.reservation?.room?.code ?? '-' }}
                      </td>
                      </tr>
                      <tr class="border-b border-transparent">
                      <td class="text-left pr-2">Room Rate</td>
                      <td class="text-left pr-2">:</td>
                      <td class="text-left fw-semibold">
                          {{ formatIDR(data?.reservation?.room?.room_category?.low_season_price ?? 0) }}
                      </td>
                      </tr>

                      <!-- Extra Charge -->
                      <tr class="border-b border-transparent align-top">
                      <td class="text-left pr-2">Extra Charge</td>
                      <td class="text-left pr-2">:</td>
                      <td class="text-left fw-semibold">
                          <div v-if="!data?.reservation?.extracharge?.length">-</div>
                          <div
                          v-else
                          v-for="(item, index) in data?.reservation?.extracharge"
                          :key="index"
                          >
                          {{ item.extra_charge?.name }} (Qty: {{ item.quantity }}, {{ formatIDR(item.extra_charge?.price ?? 0) }})
                          </div>
                      </td>
                      </tr>

                      <!-- Payments -->
                      <tr class="border-b border-transparent align-top">
                      <td class="text-left pr-2">Payment</td>
                      <td class="text-left pr-2">:</td>
                      <td class="text-left fw-semibold">
                          <div v-if="!data?.reservation?.payment?.length">-</div>
                          <div
                          v-else
                          v-for="(item, index) in data?.reservation?.payment"
                          :key="index"
                          >
                          {{ item.payment_type }} 
                          ({{ formatIDR(item.amount ?? 0) }}
                          at {{ getFormattedDate(item.payment_date) }})
                          </div>
                      </td>
                      </tr>

                      <tr class="border-b border-transparent">
                        <td class="text-left pr-2">Pending Bill</td>
                        <td class="text-left pr-2">:</td>
                        <td class="text-left fw-semibold">
                            {{ formatIDR(data?.reservation?.outstanding_balance ?? 0) }}
                        </td>
                      </tr>
                      <tr class="border-b border-transparent">
                        <td class="text-left pr-2">Total </td>
                        <td class="text-left pr-2">:</td>
                        <td class="text-left fw-semibold">
                            {{ formatIDR(data?.reservation?.total_paid ?? 0) }}
                        </td>
                      </tr>
                      <tr class="border-b border-transparent">
                        <td class="text-left pr-2">Status</td>
                        <td class="text-left pr-2">:</td>
                        <td class="text-left fw-semibold">
                            {{ data?.reservation?.payment_status ?? '-' }}
                        </td>
                      </tr>
                      
              </tbody>
          </table>
      </div>
      <br>
      <!--  Tanda tangan (print) -->
      <!-- <div class="print-only mt-8" style="display:flex;justify-content:space-between;">
        <div>
          <p>Medan, {{ new Date().toLocaleDateString('id-ID') }}</p>
          <p><strong>Petugas Resepsionis</strong></p><br><br>
          <p>______________________</p>
        </div>
        <div>
          <p>&nbsp;</p>
          <p><strong>Tamu</strong></p><br><br>
          <p>______________________</p>
        </div>
      </div> -->

    </div>

    <template #footer>
        <div class="d-flex justify-content-end">
          
          <!-- Tombol cetak muncul hanya jika modal detail aktif -->
          <BButton variant="warning" class="mr-2" @click="handlePrint">Print</BButton>
          

          <!-- <BButton variant="primary" @click="submitReservation"  class="mr-2">Save</BButton> -->
          <BButton variant="danger" @click="updateModal(false)">Close</BButton>

        </div>
    
    </template>
  </BModal>
  </template>
  
  <script>
//   defineProps({
//     data: Object,
//   })
    import { formatIDR } from "@/utils/currency";
    import { dateFormatter } from "@/utils/dateFormatter";
    import { countDays } from "@/utils/dateCalculation";
    import { getFormattedDate } from '@/composable/getDateTimeFormatter'; 

    import {
    BModal, 
    BButton,
    // BRow, 
    // BCol, 
    // BForm, 
    // BTabs,
    // BTab,
    // BFormInput,
    // BFormSelect,
    // BFormSelectOption,
    // BInputGroup, 
    // BListGroup,
    // BListGroupItem,
    // BFormTextarea, 
    // BFormRadioGroup
    } from "bootstrap-vue-next";


    export default {
    name: 'CheckOutDetail',
    components: {
        BModal,
        BButton
        // BRow, 
        // BCol,
        // BForm,
        // BTabs,
        // BTab,
        // BFormInput,
        // BFormSelect,
        // BFormSelectOption,
        // BInputGroup,
        // BButton,
        // BListGroup,
        // BListGroupItem,
        // BFormTextarea,
        // BFormRadioGroup
    },
    
    props: {
        modal: Boolean,
        data: Object,
        title:       { type: String,  default: 'Detail' },
        //modelValue:  { type: Boolean, default: false },
    },
    
    emits: ['update:modal', 'update:modelValue'],
    
    setup(props, {emit}){
      
      const updateModal = (value) => {
              emit("update:modal", value); // Sync modal state with parent
          };

      return{
          formatIDR,
          dateFormatter,
          countDays,
          getFormattedDate,
          updateModal,
          
      }
    },

    methods: {
    handlePrint () {
      // Tunggu render selesai
      this.$nextTick(() => {
        
        const printContents = document.getElementById('printArea').innerHTML;
        const printWindow = window.open('', '', 'height=600,width=800');
        printWindow.document.write('<html><head><title>Receipt Print - Deli River Hotel</title>');
        printWindow.document.write('<style>body{font-family:sans-serif;padding:20px;} h2{margin-bottom:10px;} p{margin:0 0 5px;}</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write(printContents);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      });
    }
  }    

}
</script>

<style scoped>
/* style untuk print */
@media print {
  body * {
    visibility: hidden;
  }
  #printArea, #printArea * {
    visibility: visible;
  }
  #printArea {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  button {
    display: none !important;
  }
  .navbar, .footer, .btn { display: none; }

  .print-only  { display:block !important; }
  .screen-only { display:none  !important; }


}

/* Elemen hanya layar vs hanya print */
.print-only { display:none; }
.screen-only { display:block; }

</style>